// DROPDOWNS
var $nav = $(".navbar");
var $headerDropdown = $(".navbar-dropdown");
$nav.find("a[data-dropdown]").each(function(){
  var $parent = $(this);
  $parent.on("mouseenter", function(e){
    e.preventDefault();
    var dropdownName = $parent.attr("data-dropdown")
    var $dropdown = $(`#${dropdownName}`);
    if($dropdown.length){
      $(".navbar-grid .nav-link").removeClass("active");
        $parent.addClass("active");
        $nav.addClass("always-active");
        $headerDropdown.css("pointer-events", "auto")
        $headerDropdown.addClass("navbar-dropdown--active")
        $(".navbar-dropdown-list").removeClass("navbar-dropdown-list--active")
        $dropdown.addClass("navbar-dropdown-list--active");
        if($dropdown.find(".navbar-dropdown-nested").length){
          $headerDropdown.css("min-height", $dropdown.outerHeight(true) + $(".navbar-dropdown-nested--active").outerHeight(true));
        } else {
          $headerDropdown.css("min-height", $(".navbar-dropdown-list--active").outerHeight(true) + 32);
        }
    }
  })  
})
$nav.find("a[data-nested-dropdown]").each(function(){
  var $parent = $(this);
  $parent.on("mouseenter", function(e){
    e.preventDefault();
    var dropdownName = $parent.attr("data-nested-dropdown")
    var parentDropdownName = $parent.parents(".navbar-dropdown-list").attr("id")
    var $dropdown = $(`#nested-${parentDropdownName}-${dropdownName}`);
    console.log($dropdown)
    if($dropdown.length){
        $("a[data-nested-dropdown]").removeClass("active");
        $parent.addClass("active"); 
        $(".navbar-dropdown-nested").removeClass("navbar-dropdown-nested--active");
        $dropdown.addClass("navbar-dropdown-nested--active");
        $headerDropdown.css("min-height", $(".navbar-dropdown-list--active").outerHeight(true) + $(".navbar-dropdown-nested--active").outerHeight(true));
    }
  })  
})
$nav.find("a[data-nested-dropdown]").siblings().not("[data-nested-dropdown]").each(function(){
  var $link = $(this);
  $link.on("mouseenter", function(e){
    $(".navbar-grid .nav-link, [data-nested-dropdown]").removeClass("active");
    $(".navbar-dropdown-nested").removeClass("navbar-dropdown-nested--active");
    $headerDropdown.css("min-height", $(".navbar-dropdown-list--active").outerHeight(true));
  })  
})
$(".navbar-grid .nav-link:not([data-dropdown])").on("mouseenter", function(){
  $nav.removeClass("always-active");
  if($headerDropdown.length){
    $headerDropdown.css("pointer-events", "none")
  }
  $(".navbar-grid .nav-link").removeClass("active");
  $(".navbar-dropdown").removeClass("navbar-dropdown--active");
})
$(".navbar").on("mouseleave", function(){
  $nav.removeClass("always-active");
  if($headerDropdown.length){
    $headerDropdown.css("pointer-events", "none") 
  }
  $(".navbar-grid .nav-link").removeClass("active");
  $(".navbar-dropdown").removeClass("navbar-dropdown--active");
})

// MOBILE
var mobileNavOpen = false;
function handleNavOpenClose () {
  if(mobileNavOpen){
    $(".navbar .hamburger").addClass("open")
    $(".navbar-mobile-drawer-overlay").addClass("navbar-mobile-drawer-overlay--active")
    $(".navbar-mobile-drawer").addClass("navbar-mobile-drawer--active")
    $("html").addClass("frozen");
    $("body").addClass("menu-open");
  } else {
    $(".navbar .hamburger").removeClass("open")
    $(".navbar-mobile-drawer-overlay").removeClass("navbar-mobile-drawer-overlay--active")
    $(".navbar-mobile-drawer").removeClass("navbar-mobile-drawer--active")
    $("html").removeClass("frozen");
    $("body").removeClass("menu-open");
  }  
}
$(".header .hamburger").on("click", function (e) {
	// e.stopPropagation();
  mobileNavOpen = !mobileNavOpen;
  handleNavOpenClose();
});

$(".navbar-mobile-drawer-overlay").on("click", function (e) {
	// e.stopPropagation();`
  mobileNavOpen = false;
  handleNavOpenClose();
});
// ACCOUNT SHEET (signed-in customers see the "Account" text; forward clicks to the hidden shopify-account)
$(".account-sheet-trigger").on("click", function(){
  var acct = $(this).siblings("shopify-account").get(0);
  var button = acct && acct.shadowRoot && acct.shadowRoot.querySelector("button.account-button");
  if(button){
    button.click();
  } else {
    window.location.href = "/account";
  }
});

// THEME EDITOR: open a Dropdown block's panel when it or one of its cards is selected
document.addEventListener("shopify:block:select", function(e){
  var $dropdown = $(e.target).closest(".navbar-dropdown-list");
  if(!$dropdown.length) return;
  $nav.find(`a[data-dropdown="${$dropdown.attr("id")}"]`).trigger("mouseenter");
});
